import { render, staticRenderFns } from "./classResult.vue?vue&type=template&id=4ec49002&scoped=true&"
import script from "./classResult.vue?vue&type=script&lang=js&"
export * from "./classResult.vue?vue&type=script&lang=js&"
import style0 from "./classResult.vue?vue&type=style&index=0&id=4ec49002&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec49002",
  null
  
)

component.options.__file = "classResult.vue"
export default component.exports